import {fieldPathJoinGetter} from "../../utils/kp3Utils";

export const entity = {
    name: "StakeholderType",
    fields: [
        {path: "code", unique: true},
        {path: "name"},
        {
            path: "translatedName",
            fieldPath: ["name"],
            $f: function (object, context, callback) {

                const translate = context?.translateName || (w => w)

                return callback(null, object.name && translate(object.name))
            }
        },
        fieldPathJoinGetter({
            path: "codeName",
            fieldPath: ["code", "translatedName"],
            joinString: " - "
        })
    ]
}

export const module_ = {
    object: "StakeholderType",
    tKey: "mTitle_stakeholderType",
    category: {
        path: "referential",
        icon: 'server'
    },
    defaultSortBy: "code",
    defaultSortDirection: "ASC",
    viewMap: {
        dt: [
            "code",
            {path: "name", translateName: true},
        ],
        form: [
            {path: "code"},
            {path: "name", type: "textarea"},
        ]
    }
}
